import { Dialog } from '@myosh/odin-components';
import { useRef } from 'react';
import type { RecordResult } from '../../../../@types/records';
import Notifications from '../../../notifications/notifications.component';
import Record, { RecordSaveState } from '../../../record/record.component';

export const createLinkedRecordToasterId = 'create-linked-record';

interface CreateLinkedRecordProps {
  header: string;
  visible: boolean;
  data: RecordResult | undefined;
  formId: number;
  hidden: () => void;
  onRecordCreated: (recordId: number) => void;
  fieldId: number;
  parentRecordId?: number;
  isTextualQuestionnaireLinkedRecords?: boolean;
}

const CreateLinkedRecord = (props: CreateLinkedRecordProps) => {
  const {
    header,
    visible,
    data,
    hidden,
    formId,
    onRecordCreated,
    fieldId,
    parentRecordId,
    isTextualQuestionnaireLinkedRecords,
  } = props;

  const linkedRecordId = useRef<number | undefined>(undefined);

  const onClose = () => {
    if (linkedRecordId.current) {
      onRecordCreated(linkedRecordId.current);
      linkedRecordId.current = undefined;
    }
    hidden();
  };

  const handleLinkedRecordCreated = (id: number) => {
    linkedRecordId.current = id;
  };

  const dialogId = 'create-linked-record-dialog';

  return (
    <>
      {visible && (
        <Dialog id={dialogId} header={header} visible={visible} onClose={onClose} fullScreen>
          <Record
            formId={formId}
            reverseLinkedRecords={data ? [data] : undefined}
            reverseRecordLinkFormId={data?.formId}
            onClose={onClose}
            recordState={RecordSaveState.New}
            isLinkedRecord={true}
            onLinkedRecordCreated={handleLinkedRecordCreated}
            parentLinkedRecordId={parentRecordId}
            parentLinkedFieldId={fieldId}
            isTextualQuestionnaireLinkedRecords={isTextualQuestionnaireLinkedRecords}
          />
          {/* Record notifications are behind the dialog, Use toasterId to target notifications here */}
          <Notifications
            appendTo={document.getElementById(dialogId) ?? document.body}
            toasterId={createLinkedRecordToasterId}
          />
        </Dialog>
      )}
    </>
  );
};

export default CreateLinkedRecord;
